/* eslint-disable */
import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, redirect, useLoaderData, useLocation, useNavigate } from 'react-router-dom';

import { getFaqLinks } from '@/store/footer/actions';
import { getIncome } from '@/store/income/actions';
import { clearUnReadNotifications, setUnReadNotifications } from '@/store/notifications-new/actions';
import { getUser, setUserFromDB } from '@/store/users/actions';

import { selectFooter } from '@/store/footer/selectors';
// notifications справа внизу
import { selectNotifications } from '@/store/notifications/selectors';
import { selectUsers } from '@/store/users/selectors';

import { App, Button, Layout } from 'antd';
import MobileNav from '@/components/MobileNav/MobileNav';
import NewsWidget from '@/components/NewsWidget';
import { useNotificationTypes } from '@/components/NotificationTypes';
import WelcomeModal from '@/components/WelcomeModal';

import Footer from '../Footer';
import IncomeModal from '../IncomeModal';
import ProfileModal from '../ProfileModal';
import SendReviewModal from '../SendReviewModal';

import { clearStorage } from '@/utils/clearStorage';
import Notifications from '@shared/components/Notifications';
import { changeLanguage } from '@shared/utils/changeLanguage';

import allRoutes, { collectionTopics, planning } from '@/router/routes';
import ConnectStompClient from '@/sockets/notifications.socket';
import store from '@/store';
import Utils from '@/Utils';
import Header from '@project/pages/Header/index';
import dayjs from 'dayjs';
import i18n from 'i18next';
import _ from 'lodash';
import _get from 'lodash/get';
import { io } from 'socket.io-client';

import { LOGIN } from '@/constants/income-types';
import { NEW } from '@/constants/user-statuses';

import '@shared/controllers/registerAllCharts.js';

import { AUTH_TYPES } from '@shared/pages/Login/constants';
import { selectCompany } from '@shared/store/company/selectors';
import { domainCompanyid, isTDCompany } from '@shared/utils/domainCompanyId';

import { getUserInDB } from '@/store/users/reducer';

import css from './userLayout.module.scss';

const { Content } = Layout;

const jivaCompanies = [
  {
    company: 'severstal',
    companyId: 6953,
    src: `//code.jivo.ru/widget/OGfsNzLK9b`,
    id: 'severstal-script',
    onLoad: () => console.log('SeverStal Jivo script loaded!'),
  },
];

const addScript = ({ src, id, onLoad, content, isHeader }) => {
  const existing = document.getElementById(id);
  if (existing) {
    return existing;
  } else {
    const script = document.createElement('script');
    if (src) script.src = src;
    script.id = id;
    script.async = true;
    script.onload = () => {
      if (onLoad) {
        onLoad();
      }
    };
    script.onerror = () => console.log('Error Jiva');

    script.innerHTML = content;

    if (isHeader) {
      document.head.appendChild(script);
    } else {
      document.body.appendChild(script);
    }

    return script;
  }
};

export const userChildren = allRoutes;

let abortController = null;

export const userLoader = async props => {
  const hasToken = localStorage.getItem('authorizationToken');
  const currentState = store.getState();
  const currentUser = currentState.users.currentUser;
  const isLoading = currentState.users.isLoading;

  if (!hasToken) return redirect('/user-login/');

  if (currentUser) return null;

  // Если уже идет загрузка, ждем её завершения
  if (isLoading) {
    await new Promise(resolve => {
      const unsubscribe = store.subscribe(() => {
        const state = store.getState();
        if (!state.users.isLoading) {
          unsubscribe();
          resolve();
        }
      });
    });
  }

  if (store.getState().users.currentUser) return null;

  // Отменяем предыдущий запрос, если он есть
  if (abortController) abortController.abort();

  abortController = new AbortController();

  const userActions = {
    onSuccess: response => {
      const isAbsolute = response?.domainCompany?.id === domainCompanyid.ABSOLUTE;

      // Defer dispatch to avoid setState during render
      setTimeout(() => {
        store.dispatch(getFaqLinks(isAbsolute));
      }, 0);
      changeLanguage(i18n, dayjs, response.language);

      const isExternalLogin = response?.domainCompany?.providers?.some(provider => provider.type === AUTH_TYPES.OAUTH);

      isExternalLogin ? localStorage.setItem('externalLogin', 'true') : localStorage.removeItem('externalLogin');
    },
    onError: error => {
      if (error.status === 401) clearStorage();
      return null;
    },
  };

  if (window.navigator.onLine) {
    await store.dispatch(getUser(userActions, null, abortController.signal));
  } else {
    const dbUser = await getUserInDB();

    if (dbUser?.[0]) {
      // Defer dispatch to avoid setState during render
      setTimeout(() => {
        store.dispatch(setUserFromDB(dbUser?.[0]));
      }, 0);
      userActions.onSuccess(dbUser?.[0]);
    }
  }

  return null;
};

export default function UserLayout() {
  const { t } = useTranslation(['routes', 'notifications']);

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { notification, message: messageApi } = App.useApp();

  const { currentUser } = useSelector(selectUsers);
  const { links } = useSelector(selectFooter);
  const currentNotifications = useSelector(selectNotifications);
  const { company } = useSelector(selectCompany);

  const [socket, setSocket] = useState(null);
  const [eventRequest, setEventRequest] = useState(null);
  const [rejectCode, setRejectCode] = useState(
    new URL(document.location.href).searchParams.get('manager-reject') || ''
  );
  const [profileModalVisible, setProfileModalVisible] = useState(false);
  const [visibleWelcomeModal, setVisibleWelcomeModal] = useState(true);
  const [isRootInjection, setIsRootInjection] = useState(false);
  const [visibleBurgerMenu, setVisibleBurgerMenu] = useState(false);
  const [routesConfig, setRoutesConfig] = useState([]);
  const [showNewsWidget, setShowNewsWidget] = useState(false);
  const [welcomeOpen, setWelcomeOpen] = useState(currentUser?.firstLogin);

  const loaderData = useLoaderData();

  const handleCancel = () => {
    setProfileModalVisible(false);
    if (currentUser?.firstLogin) {
      dispatch(getIncome(currentUser.id, LOGIN));
    }
  };

  const createNotification = ({ type, message }) => {
    messageApi.open({ type, content: message });
  };

  const isAbsolute = currentUser?.domainCompany?.id === domainCompanyid.ABSOLUTE;

  const acceptedCookies = localStorage.getItem('acceptCookieButton') === 'true';

  const handleAcceptCookies = () => {
    localStorage.setItem('acceptCookieButton', 'true');
    notification.destroy('cookie-notification');
  };

  const openCookieNotification = () => {
    notification.open({
      key: 'cookie-notification',
      duration: 0,
      placement: 'bottomLeft',
      className: 'cookie-notification',
      message: false,
      closeIcon: false,
      showProgress: true,
      pauseOnHover: true,
      description: (
        <div className={css['CookieNotification']}>
          <span>
            {t('notifications:cookieMessage')} <br />
            <a href='https://kampus.team/absolut/cookies_policy.pdf' target='_blank' rel='noopener noreferrer'>
              {t('notifications:readMore')}
            </a>
          </span>
          <div className={css['CookieNotification-btn']}>
            <Button type='primary' onClick={handleAcceptCookies}>
              {t('notifications:accept')}
            </Button>
          </div>
        </div>
      ),
    });
  };

  useLayoutEffect(() => {
    document.documentElement.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [location.pathname]);

  useEffect(() => {
    if (isAbsolute && !acceptedCookies) {
      openCookieNotification();
    }
  }, [isAbsolute, acceptedCookies, t]);

  useEffect(() => {
    if (currentNotifications.type) {
      // Use a timeout to ensure this runs after render
      const timeoutId = setTimeout(() => {
        createNotification({
          type: currentNotifications.type,
          message:
            currentNotifications.errorMessage ||
            t('notifications:' + currentNotifications.action, {
              data: currentNotifications.data,
            }),
        });
      }, 0);

      return () => clearTimeout(timeoutId);
    }
  }, [currentNotifications, t]);

  useEffect(() => {
    if (localStorage.getItem('authorizationToken') && currentUser?.domainCompany?.hasChat && !socket) {
      const port = import.meta.env.PUBLIC_WEBSOCKET_PORT;
      const socketUrl = port
        ? `${window.location.protocol}//${window.location.hostname}:${port}`
        : `${window.location.origin}`;

      const newSocket = io.connect(socketUrl, {
        transports: ['websocket'],
        path: '/api/v3/socket',
        auth: {
          token: localStorage.getItem('authorizationToken'),
        },
      });
      setSocket(newSocket);
    }
  }, [localStorage.getItem('authorizationToken'), currentUser?.domainCompany?.hasChat]);

  useEffect(() => {
    if (location?.pathname) {
      const isShow = [`/${collectionTopics.path}`, `/${planning.path}`, '/'].includes(location.pathname);
      setShowNewsWidget(isShow);
    }
  }, [location]);

  useEffect(() => {
    const redirectIfOffline = () => {
      const isTopicPage = location.pathname.includes('/collection-topics/');

      if (!Utils.isOnline() && !isTopicPage) {
        navigate('/offline-materials', { replace: true });
      }
    };

    redirectIfOffline();
    window.addEventListener('offline', redirectIfOffline);

    return () => {
      window.removeEventListener('offline', redirectIfOffline);
    };
  }, [location.pathname, navigate]);

  useEffect(() => {
    if (currentUser.status === NEW) {
      setProfileModalVisible(true);
    }

    const currentCompany = jivaCompanies.filter(jiv => jiv.companyId === currentUser.domainCompany.id);
    currentCompany.map(item => {
      addScript({
        src: item.src,
        id: item.id,
        onLoad: item.onLoad,
      });
    });

    const yandexMetrika = [
      {
        content: `(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)}; m[i].l=1*new Date(); for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }} k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)}) (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym"); ym(98080124, "init", { clickmap:true, trackLinks:true, accurateTrackBounce:true, webvisor:true })`,
        id: 'yandex-metrika-script-2',
        onLoad: () => console.log('Yandex metrika script loaded!'),
        errorMsg: 'Yandex metrika load error',
      },
    ];

    if (
      import.meta.env.PROD &&
      currentUser.domainCompany.id === 2 &&
      currentUser.domainCompany.domain.includes('tochka.kampus.team')
    ) {
      yandexMetrika.map(item => {
        addScript({
          id: item.id,
          onLoad: item.onLoad,
          content: item.content,
          isHeader: true,
        });
      });
    }

    return () => {
      if (socket) {
        socket.disconnect();
        setSocket(null);
      }
    };
  }, []);

  const hasCoins = currentUser?.domainCompany?.hasCoins;

  return (
    <Layout>
      <Layout>
        <Header socket={socket} openBurgerMenu={visibleBurgerMenu} setOpenBurgerMenu={e => setVisibleBurgerMenu(e)} />
        <MobileNav
          openBurgerMenu={visibleBurgerMenu}
          setOpenBurgerMenu={e => setVisibleBurgerMenu(e)}
          pathname={location.pathname}
        />

        <Layout.Content className={css['content']}>
          <Outlet context={{ socket }} />
        </Layout.Content>

        <Footer domainCompany={currentUser?.domainCompany} footerLinks={links} />
      </Layout>

      <Notifications
        enableWebSocket={true}
        clearUnReadNotifications={clearUnReadNotifications}
        setUnReadNotifications={setUnReadNotifications}
        useNotificationTypes={useNotificationTypes}
        ConnectStompClient={ConnectStompClient}
      />
      {showNewsWidget && <NewsWidget />}

      <ProfileModal visible={profileModalVisible} onCancel={handleCancel} />
      <SendReviewModal />
      {hasCoins && <IncomeModal />}

      {isTDCompany(company) && welcomeOpen && <WelcomeModal open={welcomeOpen} onClose={() => setWelcomeOpen(false)} />}
    </Layout>
  );
}
